import React from 'react';

const Head = () => (
  <thead>
    <tr>
      <th className="settings-modules__block-body--img"> </th>
      <th className="settings-modules__block-body--name"> </th>
      <th className="settings-modules__block-body--actions"> </th>
    </tr>
  </thead>
);

export default Head;
